$(function() {
  dateInit();
});

dateInit = () =>{
  $("#huratips-delivery-date").datepicker( {
    beforeShowDay:
    function(dt)
    {
      return [dt.getDay() == 1 || dt.getDay() == 2 || dt.getDay() == 3 || dt.getDay() == 4 || dt.getDay() == 5 || dt.getDay() == 6, ""];
    },
    onSelect: dateSelect
  });
}

dateSelect = (sd) =>{
  $.post('/cart/update.js', {
    attributes: {
      'date': sd
    }
  });
}


// Credit: https://stackoverflow.com/questions/4220126/run-javascript-function-when-user-finishes-typing-instead-of-on-key-up
//setup before functions
var typingTimer;                //timer identifier
var doneTypingInterval = 1500;  //time in ms, 5 second for example
var $input = $('#CartSpecialInstructions');

//on keyup, start the countdown
$input.on('keyup', function () {
  clearTimeout(typingTimer);
  typingTimer = setTimeout(doneTyping, doneTypingInterval);
});

//on keydown, clear the countdown 
$input.on('keydown', function () {
  clearTimeout(typingTimer);
});

//user is "finished typing," do something
function doneTyping (txt) {
  var $val = $input.val();
  $.post('/cart/update.js', {
    note: $val
  });
}